import React from "react";
import "./assets/scss/themes.scss";
import '../node_modules/nouislider/dist/nouislider.css';
import RouteIndex from "Routes/Index";

// import fakeBackend from "./helpers/AuthType/fakeBackend";
import { initAzureBlobStorageBackend } from "helpers/azure_helper";

// Activating fake backend
// fakeBackend();

// Import Firebase Configuration file
import { initFirebaseBackend } from "./helpers/firebase_helper";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_DATABASEURL,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENTID,
};

// init firebase backend
initFirebaseBackend(firebaseConfig);

// init azure backend
const azureBlobAccountName = process.env.REACT_APP_AZURE_BLOB_ACCOUNT_NAME;
const azureBlobAccountKey = process.env.REACT_APP_AZURE_BLOB_ACCOUNT_KEY;
if (azureBlobAccountName && azureBlobAccountKey) {
  initAzureBlobStorageBackend(azureBlobAccountName, azureBlobAccountKey);
}

function App() {
  return <RouteIndex />;
}

export default App;
